import { getPerspectiveId } from "@app/lib/perspective";
import StakeholdersMergePage, {
  PAGE_SIZE,
  stakeholdersMergeQuery,
} from "@app/pages/stakeholders-merge/stakeholders-merge-page";
import type { stakeholdersMergePage_Query } from "@app/queries/stakeholdersMergePage_Query.graphql";
import { environment } from "@app/relay/relay-environment";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { loadQuery } from "react-relay";

export const Route = createFileRoute("/_authed/stakeholders-merge")({
  loader: () =>
    loadQuery<stakeholdersMergePage_Query>(
      environment,
      stakeholdersMergeQuery,
      {
        perspectiveId: getPerspectiveId() ?? undefined,
        search: null,
        sort: "COST",
        sortDir: "ASC",
        limit: PAGE_SIZE,
        offset: 0,
      },
      { fetchPolicy: "network-only" }
    ),
  head: () => pageHead("Merge stakeholders"),
  component: StakeholdersMergeRoute,
});

function StakeholdersMergeRoute() {
  const queryRef = Route.useLoaderData();

  return (
    <ErrorBoundary
      fallback={
        <div className="p-6 text-red-500">Error loading stakeholders</div>
      }
    >
      <Suspense
        fallback={
          <div className="p-6 text-gray-500">Loading stakeholders…</div>
        }
      >
        <StakeholdersMergePage queryRef={queryRef} />
      </Suspense>
    </ErrorBoundary>
  );
}
